<script>
  import TextButton from '../TextButton/TextButton.svelte';
  import getTranslation, { sprintfo } from '../../utilities/getTranslation';
  import { getMyAccountHost, isSubscriptionEmpty } from './helper';
  import Button from '../Button/Button.svelte';

  export let componentInformationKeys, data, sthp, isMyAccountPage;

  const hasCurrrentSubscription = !isSubscriptionEmpty(data.currentSubscription);
  const hasUpcomingSubscription = !isSubscriptionEmpty(data.upcomingSubscription);

  const isNotAuthenticated =
    hasCurrrentSubscription && !data.currentActiveSubscription && !data.currentSubscription;
  const isFamilyMember = hasCurrrentSubscription && !data.currentSubscription.isPayingUser;
  const hasActivePlan =
    (hasCurrrentSubscription && data.currentSubscription.active) ||
    (hasUpcomingSubscription && data.upcomingSubscription.active);
  const canRestartPlan =
    (hasCurrrentSubscription && data.currentSubscription.canRestart) ||
    (hasUpcomingSubscription && data.upcomingSubscription.canRestart);

  const actionDescription = () => {
    if (hasActivePlan) {
      return isFamilyMember
        ? getTranslation(
            componentInformationKeys,
            'priceplans.cancelsubscription.familymember.text'
          )
        : getTranslation(componentInformationKeys, 'priceplans.cancelsubscription.text');
    } else if (canRestartPlan) {
      let endDate = data.currentSubscription.endDate;
      if (data.upcomingSubscription.canRestart) {
        endDate = data.upcomingSubscription.endDate;
      }

      return sprintfo(
        getTranslation(componentInformationKeys, 'priceplans.restartsubscription.text'),
        { endDate }
      );
    } else if (!hasActivePlan && !canRestartPlan && isFamilyMember) {
      return getTranslation(
        componentInformationKeys,
        'priceplans.cancelsubscription.familymember.text'
      );
    }
  };

  const getButtonLink = () => {
    if (hasActivePlan || (isFamilyMember && !hasActivePlan)) {
      return `${getMyAccountHost()}/${data.countryIso}/${
        data.language
      }/account/subscription/manage/cancel`;
    } else if (canRestartPlan) {
      return `${sthp}/${data.countryIso}/${data.language}/restart`;
    }
  };

  const getButtonText = () => {
    if (hasActivePlan) {
      return isFamilyMember
        ? getTranslation(
            componentInformationKeys,
            'priceplans.cancelsubscription.familymember.button'
          )
        : getTranslation(componentInformationKeys, 'priceplans.cancelsubscription.button');
    } else if (canRestartPlan) {
      return getTranslation(componentInformationKeys, 'priceplans.restartsubscription.button');
    } else if (!hasActivePlan && !canRestartPlan && isFamilyMember) {
      return getTranslation(
        componentInformationKeys,
        'priceplans.cancelsubscription.familymember.button'
      );
    }
  };
</script>

<style lang="scss">
  @use './index' as *;

  .footer {
    margin-block-start: spacing(4);
    text-align: center;
    color: $purple-50;

    .footer-description {
      margin-block-end: spacing(2);
      font-weight: 600;
      color: $purple-40;
    }

    .action-description {
      margin: spacing(6) auto 0;

      @include mq($from: tabletportrait) {
        width: 70%;
        display: inline-block;
      }

      p {
        margin-block-end: spacing(4);
      }
    }
  }
</style>

<div class="footer">
  <p class="footer-description">
    {getTranslation(componentInformationKeys, 'priceplans.question.text')}
  </p>
  <TextButton
    arrow="inlineEnd"
    center="true"
    href={getTranslation(componentInformationKeys, 'priceplans.faq.url')}
    target="_blank"
    rel="noopener"
  >
    {getTranslation(componentInformationKeys, 'priceplans.faq.text')}
  </TextButton>
  {#if isMyAccountPage}
    {#if !isNotAuthenticated && (hasActivePlan || canRestartPlan || (!hasActivePlan && isFamilyMember))}
      <div class="action-description">
        <p>{actionDescription()}</p>
        <Button type="hollow" link={getButtonLink()}>{getButtonText()}</Button>
      </div>
    {/if}
  {/if}
</div>
